// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"364":"94cf1415","450":"a8294982","706":"b897a8f9","786":"56520e8e","899":"8388dd56","936":"d5b886e1"}[chunkId] + ".css";
};